import React, { useState, useEffect, Suspense } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form'
import axios from "axios";
import { ReactSession } from 'react-client-session';
import {Helmet} from "react-helmet";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../Dashboard.css';
import classes from "./EditGroup.module.css";
import styles from '../Dashboard.module.css';
import 'react-tagsinput/react-tagsinput.css'

import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Footer from "../../Footer/Footer";

import noThumb from "../../../images/no-thumb.jpg";

function Groups() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { register, handleSubmit, reset, formState: { errors }} = useForm();
    const [group, setGroup] = useState([]);
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [image, setImage] = useState('');
    const [thumb, setThumb] = useState(null);
    const [privacy, setPrivacy] = useState(true);
    const [ifDisabled, setIfDisabled] = useState(false);
    ReactSession.setStoreType("localStorage");

    const logged_user = ReactSession.get('logged_user');

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/user/mygroups.php`, {
            user_id: logged_user,
            group_id: id,
            action: 'GET_MY_GROUP'
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            if(res.data.status === 'success') {
                setGroup(res.data.data);
                setImage(res.data.data.thumb);
                res.data.data.private === '0' ? setPrivacy(true) : setPrivacy(false);
                setLoading(true);
            }

            setProgress(100);
        })
    } , [id, logged_user])

    useEffect(() => {
        reset({
            'play_name': group.groupName,
            'description': group.description
        });
    }, [group]);

    const onSubmit = (e) => {
        const toast_id = toast.loading("Please wait...");

        const data = new FormData();
        data.append('user_id', logged_user);
        data.append('group_id', id);
        data.append('play-name', e.play_name);
        data.append('description', e.description);
        data.append('private', e.private);
        data.append('play-img', thumb);
        data.append('action', 'EDIT_MY_GROUP');

        let formObject = Object.fromEntries(data.entries());
        console.log(formObject);

        axios.post(`${process.env.REACT_APP_API_URL}/api/user/mygroups.php`, data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            }).then(response => {
                console.log(response.data);
                toast.update(toast_id, {render: response.data.message, autoClose: 5000, type: response.data.status, isLoading: false});
            }).catch(err => {
                console.log(err);
            })
    }

    const onImageChange = (e) => {
        setThumb(e.target.files[0]);

        let reader = new FileReader();
        reader.onload = (e) => {
            setImage(e.target.result);
        };
        
        if(e.target.files[0]){
            reader.readAsDataURL(e.target.files[0]);
        }else {
            setImage(group.thumb);
        }
    }

    const handlePrivacy = (e) => {
        if(e.target.value === '1') {
            setPrivacy(false);
        } else {
            setPrivacy(true);
        }
    }

    return (
        <>
            <Helmet>
                <title>Edit Group</title>
            </Helmet>
            <div className="container_wrapper">
                <Header />
                <div className={`${styles.main} main`}>
                    <ToastContainer />
                    <Sidebar active="groups" />
                    <div className={styles.main_content}>
                        <div className={styles.content_body}>
                            <div className={classes.page_name}>
                                        <h3>Edit Group</h3>
                                    </div>
                                    <div className={classes.panel}>
                                        <div className={classes.panel_body}>
                                            {
                                                loading && <div className="row">
                                                    <div className="col-8">
                                                        <form onSubmit={handleSubmit(onSubmit)}>
                                                            <div className="form-group">
                                                                <label>Group Name:</label>
                                                                <input {...register('play_name', {required: true})} className="form-control" type="text" placeholder="Your Group Title" />
                                                                {errors.play_name && <p className={styles.error_msg}>This field cannot be empty</p>}
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Description:</label>
                                                                <textarea {...register('description')} className="form-control" rows="3" placeholder="Your Group Description"></textarea>
                                                            </div>
                                                            <div className="form-group">
                                                                <label>Show group ?</label>
                                                                <div className={`form-group ${classes.radio}`}>
                                                                    <label className="radio inline">
                                                                        <input type="radio" {...register('private')} className="styled" value="0" checked={privacy} onClick={handlePrivacy} />Public
                                                                    </label>
                                                                    <label className="radio inline">
                                                                        <input type="radio" {...register('private')} className="styled" value="1" checked={!privacy} onClick={handlePrivacy} />Private
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div className="form-group">
                                                                <button className="btn btn-primary" type="submit">Save Changes</button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                    <div className="col-4">
                                                        <div className={`${classes.group_thumb} mt-4 mb-3`}>
                                                            <label htmlFor="">Thumbnail:</label>
                                                            <img width="100%" src={image} onError={e => {e.target.src = noThumb}} alt="thumb" />
                                                        </div>
                                                        <div className="form-group">
                                                            <label>Website Thumbnails (350px X 250px)</label>
                                                            <input className="form-control" type="file" onChange={onImageChange} />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                        </div>
                    <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Groups;